import React from 'react';
import CaseStudy from './CaseStudy';
import PipelineDiagram from './PipelineDiagram';
import projects from '../data/projects';
import './CaseStudy.css';

const project = projects.find((p) => p.slug === 'amazon-commerce-reporting');

const pipelineSteps = [
  'Amazon SP-API',
  'Raw data storage',
  'Python/SQL transformations',
  'Curated reporting model',
  'Power BI dashboard',
];

const SalesDashboard = () => {
  const icons = [
    { src: '/images/powerbi.jpg', alt: 'Power BI' },
    { src: '/images/fabric.jpg', alt: 'Microsoft Fabric' },
    { src: '/images/python-logo-1.png', alt: 'Python' },
    { src: '/images/postgres-logo.png', alt: 'PostgreSQL' },
  ];

  const slots = {
    afterPipeline: (
      <section className="case-study-section">
        <PipelineDiagram steps={pipelineSteps} />
      </section>
    ),
    afterOutcome: (
      <section className="case-study-section case-study-card">
        <h2>Supporting Visuals</h2>
        <p>
          A couple of views from the finished dashboard and semantic model — the emphasis is on the
          pipeline and modeling underneath, not the screenshots themselves.
        </p>
        <img src="/images/exec.png" alt="Executive dashboard view" className="case-study-image" />
        <p className="case-study-caption">
          KPI tiles summarizing revenue, units, and conversion, filterable by quarter, half, and week.
        </p>
        <img
          src="/images/semantic.png"
          alt="Semantic data model"
          className="case-study-image"
          style={{ marginTop: '18px' }}
        />
        <p className="case-study-caption">
          The Power BI semantic model blends fact and dimension tables from the curated reporting
          model so calculated measures stay consistent across every report built on top of it.
        </p>
      </section>
    ),
  };

  return <CaseStudy project={project} icons={icons} slots={slots} />;
};

export default SalesDashboard;
